export default __webpack_public_path__ + "static/media/Apexgram.565a2126.jpg";